<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina"> DESPACHOS DE ACEITE DESDE BODEGAS</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>                
		        <modal-ayuda></modal-ayuda>
            </v-card-text>

         <!-- tabla despachos -->
            <v-card-text>
                <v-card class="mt-2">
                    <template>
                        <v-tabs
                            fixed-tabs
                            background-color="cyan darken-3"
                            dark
                            v-model="tab"
                        >
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                            <v-tab key="desp">
                                <v-card-title>
                                    Despachos de Bodegas
                                </v-card-title>
                            </v-tab>
                            <v-tab key="stk">
                                <v-card-title>
                                    Nuevo Despacho
                                </v-card-title>
                            </v-tab>
                        </v-tabs>
                    </template>

                    <v-tabs-items v-model="tab">
                        <v-tab-item  key="desp">
                            <v-row>
                                <v-col cols="3">
                                    <date-picker class="float-right" v-model="fecha" @change="cargarDespachosAceite()" range-separator="|" range placeholder="Fecha Despachos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                                <v-col cols="6">
                                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn class="ma-2" dense @click="showModal(this)" color="green" >
                                        <v-icon dark>list</v-icon> Docs x movim
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-data-table 
                                :headers="cabeceras_despachos"
                                :items="lista_despachos"
                                :items-per-page="35"
                                item-class="filita"
                                class="elevation-2 mt-1"
                                dense
                            > 
                                
                                <template v-slot:item.fecha="{ item }">
                                    <span>{{  moment(item.fecha).format('DD-MM-YYYY') }}</span>
                                </template>
                                <template v-slot:item.opciones="{ item }"> 
                                    <v-icon title="Editar" color="blue" @click="showModalEdit(item)" class="mx-2">edit</v-icon>
                                    <v-icon title="Eliminar" color="red" @click="eliminarFila(item)" class="mx-2">delete</v-icon>
                                </template>
                                <template v-slot:item.analisis="{ item }"> 
                                    <v-icon title="Subir archivo" :color="item.url_archivo ? 'green' : 'blue'" @click="showModalArchivo(item)">opacity</v-icon>
                                    ({{ item.es_preembarque === 0 ? 'despachado' : 'asignado' }})
                                </template>
                            </v-data-table>
                        </v-tab-item>

                        <v-tab-item  key="stk">
                            <v-row>
                                <v-progress-linear 
                                    v-if="progreso_despacho"
                                    indeterminate
                                    color="#0D47A1"
                                ></v-progress-linear>
                            </v-row>
                            <v-row class="pl-1 pr-1">
                                <v-col cols="9">
                                    <v-card>
                                        <v-row class="pl-1 pr-1">
                                            <v-col cols="3">
                                                <v-select
                                                    :items="bodegas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    v-model="bodega_origen"
                                                    label="Seleccione Bodega Origen"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="3">
                                                <v-select
                                                        v-model="estanque_origen"
                                                        :items="estanques_filtrados"
                                                        label="Estanque Origen"
                                                        item-text="nombre_corto"
                                                        item-value="id"
                                                        color="blue darken-3"
                                                        persistent-hint
                                                        @change="() => {
                                                            cargarAbastecimientos();
                                                        }"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="3">
                                                <v-select
                                                    :items="bodegas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    v-model="bodega_destino"
                                                    label="Seleccione Bodega Destino"
                                                ></v-select>
                                            </v-col>
                                            
                                            <v-col cols="3">
                                                <label>Fecha Embarque</label>
                                                <date-picker 
                                                    v-model="fecha_despacho" 
                                                    placeholder ="Seleccione Fecha"
                                                    label ="Seleccione Fecha" 
                                                    format="DD-MM-YYYY" 
                                                    :default-value="fecha_despacho" 
                                                    valueType="YYYY-MM-DD"
                                                ></date-picker>
                                            </v-col>

                                            <v-col cols="3" class="pb-0 pt-0">
                                                <v-text-field 
                                                    v-model="nro_embarque" 
                                                    label="Nro de Embarque" 
                                                    @change="buscarEmbarques()" 
                                                    placeholder="Nro de Embarque"
                                                    class="pt-0"    
                                                ></v-text-field>
                                            </v-col>
                                            
                                            <v-col cols="3" class="pb-0 pt-0">
                                                <v-text-field
                                                        v-model="guia_despacho"
                                                        label="Guía Despacho"
                                                        class="pt-0"
                                                        @change="rellenarDatos"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="3" class="pb-0 pt-0">
                                                <v-text-field
                                                        v-model="cantidad_despacho"
                                                        label="Cant Despachada"
                                                        class="pt-0"
                                                        @change="calcula_propuesta()"
                                                ></v-text-field>
                                            </v-col>
                                            
                                            <v-col cols="3" class="pb-0 pt-0">
                                                <v-select
                                                        v-model="es_preembarque"
                                                        :items="lista_options"
                                                        class="pt-0"
                                                        label="Es Asignación de Embarque"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        color="blue darken-3"
                                                        persistent-hint
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row class="pl-1 pr-1" v-if="alert">
                                            <v-col>
                                                <v-alert
                                                    dense
                                                    text
                                                    type="success"
                                                >
                                                Despacho Generado Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                                                </v-alert>
                                            </v-col>
                                        </v-row>
                                        <v-row class="pl-1 pr-1">
                                        <!-- INICIO DOCUMENTOS DINAMICOS -->
                                            <v-col cols="3" class="pb-0 pt-0" v-for="(item) in datos_adicionales" :key="item.id">
                                                <v-text-field v-if="item.tipo_dato == 'Texto'"
                                                        v-model="item.valor_dato"
                                                        :label="item.documento"
                                                        class="pt-1 mb-1" 
                                                ></v-text-field>
                                                <v-text-field v-if="item.tipo_dato == 'Numero'"
                                                        v-model="item.valor_dato"
                                                        :label="item.documento"
                                                        class="pt-1 mb-1" 
                                                ></v-text-field>
                                                <v-select v-if="item.tipo_dato == 'Select'"
                                                        v-model="item.valor_dato"
                                                        :items="item.opciones"
                                                        item-text="opcion"
                                                        item-value="id"
                                                        :label="item.documento"
                                                        class="pt-0 mb-1" 
                                                ></v-select>
                                                <v-file-input v-if="item.tipo_dato == 'Archivo'"
                                                        v-model="item.valor_dato"
                                                        outlined
                                                        :label="item.documento"
                                                        class="pt-1 mb-1" 
                                                ></v-file-input>
                                                <label v-if="item.tipo_dato == 'Fecha'" class="pt-0">{{item.documento}}</label>
                                                <date-picker v-if="item.tipo_dato == 'Fecha'"
                                                        v-model="item.valor_dato"
                                                        placeholder ="Seleccione Fecha"
                                                        :label="item.documento"
                                                        format="DD-MM-YYYY"
                                                        valueType="YYYY-MM-DD"
                                                        class="pt-0 mb-1" 
                                                ></date-picker>
                                            </v-col>
                                        <!-- FIN DOCUMENTOS DINAMICOS -->                                 
                                        </v-row>
                                        
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card  elevation="15">
                                        <v-col cols="12">
                                            <h2 :class="{alert: litros_restantes_despacho > 0}">Por Distribuir: {{litros_restantes_despacho}} (Lts)</h2>
                                        </v-col>

                                        <v-col cols="12">
                                            <h3 class="green lighten-4">Distribuido:</h3>
                                            <v-row v-for="d in distribuciones" :key="d.id">
                                                <v-col cols="4"> {{ d.id }}</v-col>
                                                <v-col cols="4"> {{ d.tk_destino }}</v-col>
                                                <v-col cols="4"> {{ d.propuesta }} </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col cols="12">
                                            <h3 title="Botón Grabar se habilita cuando se ha distribuido el despacho" class="green lighten-4">Grabar</h3>
                                            <div class="d-flex justify-center pa-2">
                                                <v-btn color="green accent-4" v-if="litros_restantes_despacho == 0" @click="grabar_propuesta()"><v-icon>done</v-icon> Grabar </v-btn>
                                                <v-btn class="ml-6" color="orange accent-4" @click="zerou()"><v-icon @click="zerou()">clear</v-icon> Limpiar </v-btn>
                                            </div>
                                        </v-col>
                                    </v-card>

                                    <v-card class="mt-3" elevation="15">
                                        <table class="tabla">
                                            <thead>
                                                <th class="cabecera"> Embarque </th>
                                                <th class="cabecera"> Guía </th>
                                                <th class="cabecera"> Estanque </th>
                                                <th class="cabecera"> Cantidad </th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, idx) in embarques" :key="idx">
                                                    <td cols="3" class="filita text-right"> {{ row.nro_embarque }} </td>
                                                    <td cols="3" class="filita text-right"> {{ row.guia }} </td>
                                                    <td cols="3" class="filita text-right"> {{ row.estanque }} </td>
                                                    <td cols="3" class="filita text-right"> {{ row.cantidad | formatear_miles }} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <v-col cols="12">
                                            <v-row>
                                                <th class="cabecera" width="100%"> Total </th>
                                            </v-row>
                                            <v-row>
                                                <td width="100%" class="filita text-right"> {{ total_embarques | formatear_miles}} </td>
                                            </v-row>
                                        </v-col>
                                    </v-card>
                                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                                </v-col>
                            </v-row>        

                            <div class="table-wrap">
                                <v-simple-table
                                    fixed-header
                                    width="100%"
                                    height="90vh"
                                >
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th width="7%" class="cabecera borde-left">Fecha Prod.</th>
                                                <th width="5%" class="cabecera borde-left">Cant Desp.</th>
                                                <!-- <th width="5%" class="cabecera borde-left"> </th> -->
                                                <th width="7%" class="cabecera borde-left">Fecha Abast.</th>
                                                <th width="5%" class="cabecera borde-left">Folio Ab.</th>
                                                <th width="5%" class="cabecera borde-left">Estanque</th>
                                                <th width="10%" class="cabecera borde-left">Lote</th>
                                                <th width="5%" class="cabecera borde-left">Litros</th>
                                                <th width="5%" class="cabecera borde-left">Despachado</th>
                                                <th width="5%" class="cabecera borde-left">Disponible</th>
                                                <th width="10%" class="cabecera borde-left">A Despachar</th>
                                                <th width="5%" class="cabecera borde-left">Despacho</th>
                                                <th width="7%" class="cabecera borde-left">Fecha Desp.</th>
                                                <th width="9%" class="cabecera borde-left">N° Embarque/Guía</th>
                                            </tr>
                                        </thead>

                                        <tr v-for="(item) in abastecimientos" :key="item.id">
                                            <template v-if="((item.mov_tk == estanque_origen) || !estanque_origen) && item.tk_destino" >
                                                <td class="filita">
                                                    <p v-if="item.fecha_prod === 'Reproceso'">{{ item.fecha_prod }}</p>
                                                    <p v-else>{{item.fecha_prod | formatearFecha}}</p>
                                                </td>
                                                <td class="filita"><p @click="imprimir()">{{item.cantidad_desp}}</p></td>
                                                <!--  <td class="filita"><v-icon class="green" @click="addRow(item)">add</v-icon></td>  -->
                                                <td class="filita"><p v-if="item.mostrar == 1">{{item.fecha_mov | formatearFecha}}</p></td>
                                                <td class="filita"><p v-if="item.mostrar == 1">{{item.mov_folio_ab}}</p></td>
                                                <td class="filita"><p v-if="item.mostrar == 1">{{item.tk_destino}}</p></td>
                                                <td class="filita"><p v-if="item.mostrar == 1">{{item.mov_lote}}</p></td>
                                                <td class="filita"><p v-if="item.mostrar == 1">{{item.mov_litros}}</p></td>
                                                <td class="filita"><p v-if="item.mostrar == 1">{{item.despachado}}</p></td>
                                                <td class="filita">
                                                    <p v-if="item.mostrar == 1">{{ parseInt(item.mov_litros || 0) - parseInt(item.despachado || 0) }}</p>
                                                    <v-icon v-if="item.mostrar == 1"  @click="addDisponible(item)">assignment_turned_in</v-icon>
                                                </td>
                                                <td :class="`${item.color != 1 ? `propuesta-${item.color}` :''}`"> 
                                                    <v-text-field hide-details="auto" class="pt-0 text-right" v-model="item.propuesta" @change="validaPropuesta(item,$event)"> </v-text-field>
                                                </td>
                                                <td class="filita">{{item.cantidad_exp}}</td>
                                                <td class="filita">{{item.fecha_exp | formatearFecha}}</td>
                                                <td class="filita">{{item.guia_exp}}</td>

                                            </template>     <!-- 0 = disponible | 1 = tiene despacho total | 2 = tiene despacho parcial | 3 = se propone despacho | 5 = se pasa del valor máximo  -->
                                        </tr>
                                    </template>
                                </v-simple-table>
                            </div>

                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-card-text>
        </v-card>
        <modal-docs @cargarDocumentos="cargarDocumentos"></modal-docs>
        <modal-edit 
            :bodegas="bodegas" 
            :documentos="documentos" 
            :datos_adicionales="datos_adicionales"
            :estanques="estanques"
            @modal-cerrada="actualizarFila"
            @limpiar_campos="limpiarCampos"
        ></modal-edit>
        <modal-archivo @recargar_desde_modal_archivo="cargarDespachosAceite" ></modal-archivo>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Loader_Lineal_Configurable from '@/components/shared/Loader_Lineal_Configurable.vue';
import DocumentosDeMovimientos from '../../components/shared/DocumentosDeMovimientos.vue';
import ModalEditar from '../../components/shared/Modal_Aceite_Editar.vue';
import ModalArchivo from '../../components/shared/Modal_Archivo.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

// import axios from 'axios'
export default {
    data:()=>({
        tab: null,

        // Datos precargados
        bodegas: [],
        documentos: [],
        estanques:[],
        abastecimientos: [],
        lista_despachos: [],
        lista_options:[{"id":0, "nombre":'Despachado'}, {"id":1, "nombre":'Asignado'}],

        embarques:[],
        info_embarque:[],
        despacho: {},
        despachos: [],

        // Valores de tab "nuevo despacho":
        bodega_origen: '',
        bodega_destino: '',
        estanque_origen: '',
        fecha_despacho: new Date().toISOString().substr(0, 10),
        nro_embarque: '',
        guia_despacho:'',
        cantidad_despacho: 0,
        es_preembarque: 0,
        datos_adicionales: [],

        fecha: new Date().toISOString().substr(0, 10),
        dialog: false,
        alert:false,
        progreso_despacho:false,
        //configuracion para datatable  'fecha', 'nro_embarque', 'guia',  DB::Raw('b1.nombre AS bodega_origen, b2.nombre AS bodega_destino, SUM(dam.cantidad) as cantidad')
        cabeceras_despachos:[
            { text: 'Fecha',        align: 'center',    sortable: true,     value: 'fecha',             class: 'cabecera',},
            { text: 'Origen',       align: 'center',    sortable: true,     value: 'bodega_origen',     class: 'cabecera',},
            { text: 'Destino',      align: 'center',    sortable: true,     value: 'bodega_destino',    class: 'cabecera',},
            { text: 'Nro Embarque', align: 'center',    sortable: true,     value: 'nro_embarque',      class: 'cabecera',},
            { text: 'Guia',         align: 'center',    sortable: true,     value: 'guia',              class: 'cabecera',},
            { text: 'Cantidad',     align: 'center',    sortable: true,     value: 'cantidad',          class: 'cabecera',},
            { text: 'Opciones',     align: 'center',    sortable: true,     value: 'opciones',          class: 'cabecera',},
            { text: 'Análisis',     align: 'center',    sortable: true,     value: 'analisis',          class: 'cabecera',},
        ],
    }),
    mounted() {
        this.cargarBodegas();
        this.cargarDocumentos();
        this.cargarEstanques();
        this.cargarAbastecimientos();
        this.cargarDespachosAceite();
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Despachos de Aceite desde bodegas externas`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`Esta pantalla muestra los despachos realizados desde las bodegas externas y permite realizar un nuevo despacho.`},
                        {   tipo:`label`,   texto:`- Despachos de Bodegas: Muestra despachos realizados y se puede realizar búsquedas por fecha.`},
                        {   tipo:`label`,   texto:`- Nuevo Despacho: Se registran los datos del embarque y en la tabla inferior se va seleccionando el origen del producto despachado.`},
                        {   tipo:`imgtexto`,  url:`help-nuevo-despacho.png`,  ratio:'6.5', cols:'2', texto:` - Los despachos se registran por Guía de Despacho. Al escribir un numero de embarque, el sistema busca las guias que ya se han registrado de ese embarque`},
                        {   tipo:`imgtexto`,  url:`help-por-distribuir.png`,  ratio:'2', cols:'1', texto:` - Esta tabla muestra cuanto de lo que se digitó en "Cant Despachada" falta destribuir (indicar el origen). Al distribuir todo, se habilita el botón de grabar.  \n - Al Grabar se mantienen los datos del encabezado para poder seguir registrando otras guías de un mismo embarque.`},
                        {   tipo:`imgtexto`,  url:`help-distribuir-desp.png`,  ratio:'4', cols:'2', texto:` - En la columna "A Despachar" se registra el origen del producto. El sistema valida que no se despache mas de lo "Disponible" o recibido ("columna Litros"). Se puede despachar de diferentes filas. `},
                        {   tipo:`label`,   texto:``},
                   
                   ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarBodegas(){
            this.mostrarLoading({titulo:'Cargando bodegas...',color:'green'})
            let url = `${this.base_url}bodegas?tipo_produccion_id=2`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar bodegas ");
                console.log('error',error);
            });
        },
        async cargarDocumentos(){
            this.documentos = [];
            this.datos_adicionales = [];
            await this.axios.get(`${this.base_url}mov_documentos?tipo_movimiento=S&motivo_movimiento=5&tipo_produccion_id=2&limit=99999999`,this.headers).then((res)=>{
                this.documentos = res.data.data.data;
                this.documentos.forEach(d => {
                    this.datos_adicionales.push({
                        mov_documentos_id:d.id,
                        valor_dato:'',
                        tipo_dato:d.tipo_dato_texto,
                        documento:d.documento,
                        opciones:d.opciones
                    });
                });
            }).catch((e)=>{
                console.log(e);
            });
        },
        closeDialog(){
            if(this.litros_restantes_despacho > 0){
                console.log('Falta distribuir')
                this.dialog = true;
                return
            }
            this.dialog = false;
        },

        async cargarEstanques(){
            this.mostrarLoading({titulo:'Cargando estanques externos...',color:'green'})
            let url = `${this.base_url}estanques_externos/0`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.estanques = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.errorMessage(error, "Error al cargar estanques externos ");
            });
        },

        async cargarDespachosAceite(){
            let fecha_ini = this.moment(this.fecha[0]).format('YYYY-MM-DD');
            let fecha_fin = this.moment(this.fecha[1]).format('YYYY-MM-DD');
            let data = {    "fecha_ini": fecha_ini,
                        "fecha_fin": fecha_fin  }
            let url = `${this.base_url}despacho_aceite/despachos_bodegas`;
            await this.axios.post(url, data, this.headers).then((response) => {
                this.lista_despachos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },

        showModalEdit(fila) {
            this.$emit("abrir_modal_edit", fila);
        },

        showModalArchivo(fila) {
            const config = {
                view: "despacho",
                info_cargar: {
                    cargar: true,
                    url: `${this.base_url}despacho_aceite/buscar_despacho/${fila.id}`,
                    ubicacion: 'info',
                },
                info_subir: {
                    url: `${this.base_url}despacho_aceite/subir_archivo/${fila.id}`,
                },
                info_descargar: {
                    url: `${this.base_url}despacho_aceite/descargar_archivo/${fila.id}`,
                    path: 'movimientos/analisis_aceite',
                },
                info_eliminar: {
                    url: `${this.base_url}despacho_aceite/eliminar_archivo/${fila.id}`,
                    confirm_message: `¿Desea eliminar el archivo de análisis externo de guía ${fila.guia} de bodega externa?`,
                }
            }
            this.$emit("abrir_modal_archivo", fila, config);
        },

        actualizarFila(filaActualizada) {
            const filaIndex = this.lista_despachos.findIndex(t => t.id === filaActualizada.id);
            if (filaIndex !== -1) {
                this.lista_despachos.splice(filaIndex, 1, filaActualizada);
            }
        },

        async eliminarFila(fila){
            let data = {    "guia": fila.guia,
                            "embarque": fila.nro_embarque  }
            let url = `${this.base_url}despacho_aceite/eliminar_despacho`;
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: 'Desea eliminar despacho de guía '+ fila.guia +' de bodega externa?',
                okButton: 'Eliminar !!',
            })
            if(okei) {
                await this.axios.post(url, data, this.headers).then((response) => {
                    console.log(response.data)
                    this.cargarDespachosAceite()
                    this.mostrarLoading({titulo:response.data.message,color:'green'})
                }).catch((error)=>{
                    console.log(error);
                    this.errorMessage(error, "Error al eliminar ");
                });
            }
        },

        async buscarEmbarques(){
            let url = `${this.base_url}despacho_aceite/embarques/${this.nro_embarque}`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.embarques = res.data.data.data.map(emb => {
                    return {
                        ...emb,
                        estanque_id: emb.estanque,
                        estanque: this.estanques.find(e => e.id === emb.estanque).nombre,
                    }
                });
                this.info_embarque = res.data.data.info;
                if (!this.bodega_origen) this.bodega_origen = this.info_embarque.bodega_origen
                if (!this.bodega_destino) this.bodega_destino = this.info_embarque.bodega_destino
                if (!this.fecha_despacho) this.fecha_despacho = this.info_embarque.fecha
                let info = this.info_embarque.informacion;
                info.forEach( row => {
                    try {
                        let idx = this.datos_adicionales.findIndex(r => r.mov_documentos_id == row.mov_documentos_id)
                        if (row.tipo_dato == "Fecha") {
                            this.$set(this.datos_adicionales[idx], "valor_dato", this.moment(row.valor_fecha).format('YYYY-MM-DD'));
                        } else {
                            this.$set(this.datos_adicionales[idx], "valor_dato", row.valor_dato);
                        }
                    } catch (err) {
                        console.log('error',err);
                    }
                });

                const rellenar = await this.rellenarCampos();
                if (rellenar) await this.cargarAbastecimientos();
            }).catch((error)=>{
                console.log('error',error);
            });
        },

        async grabar_propuesta(){
            if (this.puedoGrabar()) {
                this.progreso_despacho = true;
                let toSave = []
                let data = {}
                this.abastecimientos.forEach( row => {
                    if (row.propuesta > 0) {
                        data = { "mda_id":row.mda_id, "propuesta":row.propuesta, "estanque":row.mov_tk};
                        toSave.push( data );
                    }
                });

                data = {    "bod_origen": this.bodega_origen,
                            "bod_destino": this.bodega_destino,
                            "fecha": this.fecha_despacho, 
                            "embarque": this.nro_embarque,
                            "preembarque": this.es_preembarque,
                            "guia": this.guia_despacho,
                            "cant_desp": this.cantidad_despacho,
                            "datos_adicionales": this.datos_adicionales, 
                            "distribuido": toSave
                        }
                let url = `${this.base_url}despacho_aceite/graba_exportacion`;
                await this.axios.post(url, data, this.headers).then((response) => {
                    let resp = response.data.data;
                    this.buscarEmbarques();
                    this.cargarAbastecimientos();
                    this.guia_despacho = '';
                    this.cantidad_despacho = '';
                    this.estanque_origen = null;
                    this.zerou();
                    console.log("resp", resp)
                }).catch((error)=>{
                    console.log(error);
                });
                this.progreso_despacho = false;
            } else {
                console.log ("no se puede grabar.... que penita")
            }
            

        },
        puedoGrabar(){
            console.log(this.litros_restantes_despacho,this.bodega_origen,this.bodega_destino,this.fecha_despacho,
                        this.nro_embarque,this.guia_despacho )

            if((this.litros_restantes_despacho == 0) && (this.bodega_origen) && (this.bodega_destino) && (this.fecha_despacho) && (this.nro_embarque) && (this.guia_despacho)) {
                return true;
            } else {
                return false;
            }
        },
        addRow(item){
            let maxId  = Math.max.apply(Math, this.abastecimientos.map(function(o) { return o.id; }))
            let idx = this.abastecimientos.findIndex(r => r.id == item.id)
            let obj = Object.assign({}, item)
            obj.id = parseInt(maxId) + 1
            obj.propuesta = 0
            this.abastecimientos.splice(idx,0,obj)
            //this.abastecimientos.push()
            console.log(this.abastecimientos)
        },
        async showModal($event){
            
            this.$emit('abrir_modal_docs',null,$event);
            //this.dialog = true;
        },

        async cargarAbastecimientos(){
            let tk = this.estanque_origen ? this.estanque_origen : 0
            let url = `${this.base_url}despacho_aceite/abastecimientos/${tk}`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.abastecimientos = res.data.data;
                this.calcula_propuesta();
                this.rellenarTablaDespachos();
            }).catch((error)=>{
                console.log('error',error);
            });
            
        },
        validaPropuesta(item, event) {
            //console.log("item", item, "event", event);
            let idx = this.abastecimientos.findIndex(r => r.id == item.id)
            let lts = 0
            let lts_prod = 0
            let lts_abast = 0
            this.abastecimientos.forEach(e =>{
                lts += parseInt(e.propuesta || 0)
                if (e.dap_id == item.dap_id) {
                    lts_prod += parseInt(e.propuesta || 0)
                    console.log("e.dap_id", e.dap_id, "e.propuesta", e.propuesta, "lts_prod" , lts_prod)
                }
                if (e.mda_id == item.mda_id) {
                    lts_abast += parseInt(e.propuesta || 0)
                }
            })
            // 1 no más de lo que dice en cant despachada    2 no más de lo que ingresó menos los despachos ya hechos
            // 3 no más que el despacho de la producción original 
            let valida1 = (parseInt(this.cantidad_despacho || 0) - lts ) + parseInt(item.propuesta || 0) - parseInt(event|| 0)
            let valida2 = parseInt(item.mov_litros || 0) - lts_abast - parseInt(item.despachado || 0) + parseInt(item.propuesta || 0)  - parseInt(event|| 0)
            let valida3 = (parseInt(item.cantidad_desp || 0) - lts_prod ) + parseInt(item.propuesta || 0) - parseInt(event|| 0)

            let lts2 = Math.min(valida1, valida2, valida3)
            /*console.log("this.cantidad_despacho", this.cantidad_despacho,"lts",lts,"lts_prod",lts_prod,"item.cantidad_desp",item.cantidad_desp,
                        "lts_abast",lts_abast,"item.mov_litros",item.mov_litros,"valida1",valida1,"valida2",valida2,"despachado",item.despachado,
                        "valida3",valida3, "lts2",lts2,"item.propuesta ", item.propuesta ,"event", event);*/
            if (lts2 < 0){
                let valor = parseInt(event || 0) + parseInt(lts2 || 0);
                event = valor > 0 ? valor : 0;
                this.$set(this.abastecimientos[idx], "color", 5)
                this.$set(this.abastecimientos[idx], "propuesta", event)
            } else {
                this.$set(this.abastecimientos[idx], "color", 3)
                this.$set(this.abastecimientos[idx], "propuesta", event)
            }
        },
        imprimir(){
            this.abastecimientos.map( (row) => {
                if (row.propuesta > 0) {
                    console.log(row.id, "propuesta", row.propuesta)
                }
            })
        },
        zerou(){
            this.abastecimientos.map( (row) => {
                row.propuesta = 0
            })
        },
        calcula_propuesta(){
            let cant = 0
            let cant2 = 0
            let lts = 0
            let mov_id = 0
            this.abastecimientos.forEach(e =>{
                lts += parseInt(e.propuesta || 0) 
            })
            lts = parseInt(this.cantidad_despacho || 0)  - lts

            let tk_prod = this.abastecimientos.filter( f => {
                 return (f.mov_tk == this.estanque_origen); 
            })
            //console.log("lts", lts, "tk_prod", tk_prod)

            if (lts > 0){
                tk_prod.map( (row) => {
                    if ((lts > 0) && !row.propuesta ){ //&& (mov_id != row.mda_id) &&  row.mostrar
                        cant =  parseInt(row.mov_litros || 0) - parseInt(row.despachado || 0)
                        let lts_prod = 0
                        tk_prod.forEach(e =>{
                            if (e.dap_id == row.dap_id) {
                                lts_prod += parseInt(e.propuesta || 0) + parseInt(e.cantidad_exp || 0) 
                            }
                        });
                        cant2 =  parseInt(row.cantidad_desp || 0) - lts_prod
                        if ((cant > 0 ) && (cant2 > 0)) {
                            row.propuesta = Math.min(cant, cant2, lts)
                            lts -= row.propuesta
                        }
                        mov_id = row.mda_id
                    }
                })
            }
            //console.log('tk_prod', tk_prod)
            //return tk_prod
        },
        addDisponible(item){ // cuando hace clic en el disponible se pasa el menor valor hacia columna a despachar
            let lts = this.litros_restantes_despacho
            let disp = parseInt(item.mov_litros || 0) - parseInt(item.despachado || 0)
            let idx = this.abastecimientos.findIndex(r => r.id == item.id)

            if (lts > 0){
                let cant = Math.min(lts, disp)
                item.propuesta = cant
                this.$set(this.abastecimientos[idx], "propuesta", cant)
            }

        },
        async rellenarTablaDespachos() {
            if(this.embarques.length > 0 && this.guia_despacho && this.estanque_origen) {
                this.abastecimientos = this.abastecimientos.map(ab => {
                    if( ab.nro_embarque === this.nro_embarque &&
                        ab.guia_exp === this.guia_despacho &&
                        ab.mov_tk === this.estanque_origen ) {
                            ab.propuesta = ab.cantidad_exp;
                        } else {
                            ab.propuesta = 0;
                        }
                    return ab;
                });
            }
        },
        async rellenarDatos() {
            const rellenar = await this.rellenarCampos();
            if (rellenar) {
                this.cargarAbastecimientos();
            } else {
                this.rellenarTablaDespachos();
            }
        },
        limpiarCampos() {
            this.bodega_origen = '';
            this.bodega_destino = '';
            this.estanque_origen = '';
            this.fecha_despacho = new Date().toISOString().substring(0, 10);
            this.nro_embarque = '';
            this.guia_despacho ='';
            this.cantidad_despacho = 0;
            this.es_preembarque = 0;
            this.datos_adicionales = this.datos_adicionales.map(dato => {
                return {
                    ...dato,
                    valor_dato: '',
                }
            });
            this.abastecimientos = [];
            this.embarques = [];
        },
        async rellenarCampos() {
            let rellenar = false;
            const emb = this.embarques.find(emb => emb.guia === this.guia_despacho);
            if(emb && emb.estanque_id && this.nro_embarque && this.guia_despacho) {
                rellenar = await this.$refs.confirmDialogue.show({
                    title: '¿Quiere rellenar los campos?',
                    message: 'bodega de origen, estanque de origen y bodega de destino',
                    okButton: 'Rellenar',
                });
                
                if(rellenar) {
                    this.bodega_origen = this.info_embarque.bodega_origen;
                    this.estanque_origen = emb.estanque_id;
                    this.bodega_destino = this.info_embarque.bodega_destino;
                }
            }
            return rellenar;
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'roles']),
        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        },
        litros_restantes_despacho(){
            let litros = 0;
            if(this.cantidad_despacho){
                litros = this.cantidad_despacho;
                this.abastecimientos.forEach(e => {
                    litros -= parseInt(e.propuesta || 0);
                });
            }
            return litros;
        },
        total_embarques(){
            let litros = 0;
                this.embarques.forEach(e => {
                    litros += parseInt(e.cantidad || 0);
                });
            return litros;
        },
        distribuciones(){
            let desp = this.abastecimientos.filter( f => {
                return (f.propuesta > 0); 
            })
            return desp
        },
        estanques_filtrados() {
            if(this.bodega_origen) {
                return this.estanques.filter(estanque => estanque.bodegas_id === this.bodega_origen);
            }
            return this.estanques;
        }

    },
    components:{
        'modal':Modal,
        'modal-docs':DocumentosDeMovimientos,
        'data-table':Data_Table,
        'loader-configurable':Loader_Lineal_Configurable,
        DatePicker,
        ConfirmDialogue,
        'modal-ayuda':ModalAyudas,
        'modal-edit': ModalEditar,
        'modal-archivo': ModalArchivo,
    }
}
</script>
<style scoped>
    .mx-datepicker{ width: 100% !important;}
    .alert{ color: red;}
    /** 0 = disponible | 1 = tiene despacho total | 2 = tiene despacho parcial | 3 = se propone despacho | 5 = se pasa del valor máximo  */
    .propuesta-1{background-color: #00A2FA;}
    .propuesta-2{background-color: #00E1FA;}
    .propuesta-3{background-color: #69E312;}
    .propuesta-5{background-color: #FDDE14;}

    .filita{padding: 0em 1em; border-bottom:1px solid hsl(206, 99%, 31%) !important;}
    .fila_r{background-color: #b2dfdb;}
    .table-wrap { width: 100%;  overflow-x: auto;}
    .tablet>thead>tr>th { background-color: white; position: sticky; position: -webkit-sticky; top: 0; z-index: 2;} 

    .tabla { border-collapse: collapse; width: 100%; }

</style>